export enum MemberIdUrlKey {
  Client = "memberClientId",
  Collaborator = "collaboratorId"
}
